import { render } from "./ImportSupplier.vue?vue&type=template&id=d2c0ea18&scoped=true"
import script from "./ImportSupplier.vue?vue&type=script&lang=js"
export * from "./ImportSupplier.vue?vue&type=script&lang=js"

import "../item/importShared.css?vue&type=style&index=0&id=d2c0ea18&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c0ea18"]])

export default __exports__